<template>
  <div v-if="permittedModuleCount === 0" style="color: white;">
    <div class="d-flex justify-content-center" v-if="permissionLoader">
      <i class="fa fa-spinner fa-pulse fa-2x text-white"></i>
    </div>
    <strong v-else>No Module Authorized</strong>
  </div>
  <div v-else-if="permittedModuleCount === 1" style="color: white;">
    <img class="me-2" :src="selectedModuleObject?.SelectedImage" height="46" />
    <strong style="font-size: large;">{{ selectedModuleObject?.name }}</strong>
  </div>
  <fr-header-module-selector
    v-else
    :modules="filteredModules"
    :selected-module="selectedModuleObject"
    :persistent="persistent"
    :moduleDialog="moduleDialog && this.selectedBrandId"
    @modal-opened="whenModalOpened"
    @modal-closed="resetOnClose"
    :highlightedModuleIndex="highlightedModuleIndex"
    :subNavHighLightedModuleIndex="subNavHighLightedModuleIndex"
    ref="frHeaderModuleSelector"
  >
    <template v-slot:search-bar>
      <input type="text" ref="searchBar" placeholder="Search" class="form-control bg-light my-1 ms-1"
        style="border-radius:8px; max-width: 280px; margin-top: -62px !important;" v-model="searchModuleName" />
       
    </template>
    <template v-slot:subnav-links>
      <template v-if="filteredSubnavResults.length" v-for="(result, index) in filteredSubnavResults" :key="result.path">
        <span v-if="index < 4">
          <router-link
            :to="`/${selectedBrandUri}/${result.moduleSlug}/${result.path}`"
            style="color: inherit; text-decoration: inherit;"
            :target="selectedModule ? ( result.moduleSlug == selectedModule ? '' : '_blank') : ''"
            :ref="`subModule${index}`"
          >
            <fr-portlet class="mx-1 p-2 text-start small my-1" :class=" subNavHighLightedModuleIndex == index ? 'hightLightSubNavLink' : 'subNavLinkNormal'">
              <img class="ms-1 me-2" :src="allModules.find((module) => module.slug === result.moduleSlug)?.image" height="20" />
              <span class="fw-light">{{allModules.find((module) => module.slug === result.moduleSlug)?.name}}</span>
              &nbsp; /
              <span v-if="result.linkIcon">&nbsp; <i class="fa" :class="'fa-' + result.linkIcon" /></span>
              &nbsp; {{ result.title }}
            </fr-portlet>
          </router-link>
        </span>
      </template>
      <div v-if="!filteredModules.length && !filteredSubnavResults.length" style="margin-top: 50px;">No Results</div>
    </template>
  </fr-header-module-selector>
</template>
<script>
import { FrHeaderModuleSelector } from "@froogal.ai/ui";
import { modules } from "../components/Modules";
import { modules as subNavModules } from "@/router/index.js";
import { usePermissionStore } from "@/stores/permissions";
import { useBrandsStore } from "@/stores/brands";
import { storeToRefs } from "pinia";
import Fuse from "fuse.js";
export default {
  setup() {
    const brandStore = useBrandsStore();
    const permissionStore = usePermissionStore();
    const { permissionLoader, permissions } = storeToRefs(permissionStore);
    const { selectedBrandUri, selectedBrandId, selectedBrand } = storeToRefs(brandStore);
    const { checkAuthorization } = permissionStore;
    return {
      permissions, // ideally should be entirely replaced by checkAuthorization
      permissionLoader,
      selectedBrand,
      selectedBrandUri,
      selectedBrandId,
      checkAuthorization,
    }
  },
  props: ["selectedModule", "persistent", "moduleDialog", "permission"],
  data() {
    return {
      searchModuleName: "",
      highlightedModuleIndex: -1,
      subNavHighLightedModuleIndex: -1,
      subnavresults: [],
    };
  },
  components: {
    FrHeaderModuleSelector,
  },
  computed: {
    filteredModules: function () {
      if (this.searchModuleName) {
        const fuse = new Fuse(this.allModules, {
          keys: ['name'],
          threshold: 0.4, // Adjust this threshold as needed
        });
        return fuse.search(this.searchModuleName).map(result => result.item);
      }
      return this.allModules;
    },
    allModules: function () {
      return modules.map(m => {
        if (m.page) {
          if (typeof m.path == 'function') {
            m.fullPath = m.path(this.checkAuthorization, this.selectedBrand);
          } else {
            m.fullPath = `/${this.selectedBrandUri}${m.path}`;
          }
        } else {
          m.fullPath = m.path;
        }
        m.enable = this.checkAuthorization(m.permission, m.slug) ? true : false;
        return m;
      });
    },
    permittedModuleCount: function () {
      return this.allModules.filter((mod) => mod.enable).length;
    },
    selectedModuleObject() {
      return this.allModules.find((mod) => mod.slug.includes(this.selectedModule));
    },
    filteredSubnavResults() {
      const subFuse = new Fuse(this.subnavresults, {
        keys: ['title'],
        threshold: 0.4, // Adjust this threshold as needed
      });
      return subFuse.search(this.searchModuleName).slice(0, 5).map(result => result.item).filter((el, index) => index < 4 );
    }
  },
  watch: {
    permissions() {
      if (this.permittedModuleCount === 1 && !this.selectedModule) {
        const rerouteToModule = this.allModules.filter((mod) => mod.enable)[0].slug;
        window.open('/' + this.selectedBrandUri + '/' + rerouteToModule, '_self');
      }
    },
    searchModuleName(newValue, oldValue) {
      if (newValue) {
        this.subnavresults = subNavModules
          .flatMap((subNavModule) => {
            return subNavModule.children
              .filter((child) => child.meta.showInNav && this.checkAuthorization(child.meta.permission))
              .map((child) => ({
                moduleSlug: subNavModule.moduleSlug,
                title: child.meta.title,
                linkIcon: child.meta.linkIcon,
                path: child.path,
              }));
          });
      }
      if (newValue && !oldValue) {
        this.highlightedModuleIndex = 0;
        this.subNavHighLightedModuleIndex = -1;
      } else if (!newValue) {
        this.highlightedModuleIndex = -1;
        this.subNavHighLightedModuleIndex = -1;
        this.subnavresults = [];
      }
    },
    filteredModules() {
      this.highlightedModuleIndex = this.filteredModules.findIndex((mod) => mod.slug === this.selectedModule);
    }
  },
  methods: {
    whenModalOpened() {
      window.addEventListener('keydown', this.handleKeyDown);
      this.$nextTick(() => {
        const searchBar = this.$refs.searchBar;
        if (searchBar) {
          searchBar.focus();
        }
      });
    },
    resetOnClose() {
      this.searchModuleName = "";
      window.removeEventListener('keydown', this.handleKeyDown);
    },
    handleKeyDown(event) {
      const searchBar = this.$refs.searchBar;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key == 'ArrowUp' || event.key == 'ArrowDown' || event.key == 'Enter') {
        if (document.activeElement === searchBar) {
          event.preventDefault();
        }
      }

      if (event.key === 'ArrowLeft') {
        if (this.highlightedModuleIndex > 0) {
          this.highlightedModuleIndex -= 1;
          this.subNavHighLightedModuleIndex = -1;
        }
      } else if (event.key === 'ArrowRight') {
        if (this.highlightedModuleIndex < this.filteredModules.length - 1) {
          this.highlightedModuleIndex += 1;
          this.subNavHighLightedModuleIndex = -1;
        }
      } else if (event.key == 'ArrowUp') {
        this.highlightedModuleIndex = -1;
        if (this.subNavHighLightedModuleIndex > 0) {
          this.subNavHighLightedModuleIndex -= 1;
        } else if( this.subNavHighLightedModuleIndex -= 1 && this.filteredSubnavResults.length){
          this.subNavHighLightedModuleIndex = 0;
        }
      } else if (event.key == 'ArrowDown') {
        this.highlightedModuleIndex = -1;
        if(this.subNavHighLightedModuleIndex  < this.filteredSubnavResults.length -1) {
             this.subNavHighLightedModuleIndex += 1;
        }
      } else if (event.key == 'Enter') {
        if(this.filteredSubnavResults.length && this.subNavHighLightedModuleIndex > -1) {
          let temp = this.$refs[`subModule${this.subNavHighLightedModuleIndex}`];
          if(temp.length && temp[0].to) {
            this.$router.push(temp[0].to);
            let element = this.$refs.frHeaderModuleSelector;
            if(element) {
              element.closeModuleDialogUi();
            }
          }
        }
      }
    }
  }
};
</script>
<style>
.hightLightSubNavLink {
  background-color: #14BA7D!important;
  color: white;
}
.subNavLinkNormal {
  background-color: #f4f6f9!important;
  border: 1px solid #f4f6f9!important;
}
</style>